


import * as Actions from '../actions';

const initialState = {
    isLoading: true,
    errMsg: null,
    data: []
    };


// get active categories
export const codeVerifyAdminReducer = function(state = initialState, action) {
switch (action.type) {
case Actions.CODE_VERIFY_ATUH_ADMIN:
    console.log(action.payload)
return { ...state, isLoading: false, errMsg: null, data: action.payload };
case Actions.CODE_VERIFY_ATUH_ADMIN_LOADING:
return { ...state, isLoading: true, errMsg: null, data: [] };
case Actions.CODE_VERIFY_ATUH_ADMIN_LOADING_FAILED:
return { ...state, isLoading: false, errMsg: action.payload, data: [] };
default:
return state;
}
};
